import { render, staticRenderFns } from "./VueAppbar.vue?vue&type=template&id=284c4c53&"
import script from "./VueAppbar.vue?vue&type=script&lang=js&"
export * from "./VueAppbar.vue?vue&type=script&lang=js&"
import style0 from "./VueAppbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports